import React from 'react'

import { getEnevelopeCompletedBySelf } from '@util/CommonServicess'

import DocWhiteSVG from '@assets/images/DocWhite.svg'
import ArrowSVG from '@assets/images/Arrow.svg'
import styles from './EnvelopActionPanel.styles'

interface EnevelopActionPanelMobileProps {
    showActionLink?: boolean
    isCompleted?: boolean
    actionLink: string
    state: any
}

const EnevelopActionPanelMobile: React.FC<EnevelopActionPanelMobileProps> = ({
    showActionLink,
    isCompleted,
    actionLink,
    state,
}) => {
    return (
        <>
            {showActionLink && (
                <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                    <div style={{ marginLeft: '10px' }}>
                        {isCompleted ? (
                            <div style={styles.mobileDownloadButton} onClick={() => window.open(actionLink, '_blank')}>
                                <img src={DocWhiteSVG} />
                            </div>
                        ) : (
                            !getEnevelopeCompletedBySelf(state) && (
                                <div
                                    style={styles.mobileActionButton}
                                    onClick={() => window.open(actionLink, '_blank')}
                                >
                                    <img src={ArrowSVG} />
                                </div>
                            )
                        )}
                    </div>
                </div>
            )}
        </>
    )
}

export default EnevelopActionPanelMobile
